(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-navratri-banner"] && !Shopify.designMode) return;
  try {
    
function initFestive(root){
if(root.dataset.festiveReady)return;root.dataset.festiveReady='true';
const track=root.querySelector('[data-festive-track]'),slides=[...root.querySelectorAll('[data-festive-slide]')],dots=[...root.querySelectorAll('[data-festive-dot]')],pause=root.querySelector('[data-festive-pause]');
if(slides.length<2)return;let current=0,timer,paused=false,hovered=false,focused=false;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
function stop(){clearInterval(timer)}
function show(index){current=(index+slides.length)%slides.length;track.scrollTo({left:current*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});dots.forEach((d,i)=>d.setAttribute('aria-current',i===current?'true':'false'))}
function start(){stop();if(!paused&&!hovered&&!focused&&!reduced.matches&&!document.hidden)timer=setInterval(()=>show(current+1),5000)}
dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start()}));
pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.querySelector('span').textContent=paused?'▶':'Ⅱ';start()});
root.addEventListener('mouseenter',()=>{hovered=true;stop()});root.addEventListener('mouseleave',()=>{hovered=false;start()});
root.addEventListener('focusin',()=>{focused=true;stop()});root.addEventListener('focusout',()=>setTimeout(()=>{focused=root.contains(document.activeElement);start()},0));
track.addEventListener('scroll',()=>{current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((d,i)=>d.setAttribute('aria-current',i===current?'true':'false'))},{passive:true});
track.addEventListener('touchstart',()=>{paused=true;pause.setAttribute('aria-pressed','true');pause.querySelector('span').textContent='▶';stop()},{passive:true});
document.addEventListener('visibilitychange',start);reduced.addEventListener('change',start);window.addEventListener('resize',()=>show(current));start();
}
document.querySelectorAll('[data-cp-festive]').forEach(initFestive);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cp-festive]').forEach(initFestive));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-premium-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cp-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-cp-slide]')];
    const dots = [...hero.querySelectorAll('[data-cp-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (next) => {
      current = next % slides.length;
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        const active = index === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(current + 1), 5000);
    };
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.cpDot)); start(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-footer"]) return;
  try {
    
  document.querySelectorAll('.cp-editorial-footer').forEach((footer) => {
    const groups = footer.querySelectorAll('.cp-editorial-footer__group');
    const mobile = window.matchMedia('(max-width: 767px)');
    const syncGroups = (event) => groups.forEach((group) => {
      group.open = !event.matches;
    });
    syncGroups(mobile);
    mobile.addEventListener('change', syncGroups);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
